// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module_logo_6e354","size-S":"Logo-module_size-S_4b248","size-M":"Logo-module_size-M_813f7","size-L":"Logo-module_size-L_b5a2f","size-XL":"Logo-module_size-XL_c9bd3"};